import './ui-elements'
import './form'
import './popup'
import './animation'


jQuery(document).ready(function($) {




  $('.interest-product-slider').each(function() {
    const $slider = $(this);        
    console.log($slider);
    new Swiper($slider.find('.swiper-container')[0], {
      slidesPerView: 2,
      spaceBetween: 20, 
      loop: true, 
      navigation: {
        prevEl: $slider.closest('.center-sect').find('.js-interest-prev')[0],
        nextEl: $slider.closest('.center-sect').find('.js-interest-next')[0],
      }, 
      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 10 }, 
        768: { slidesPerView: 2, spaceBetween: 10 },
        992: { slidesPerView: 2, spaceBetween: 10 }, 
      }, 
      speed: 500,  
      grabCursor: true,
    });
  });





  $(window).scroll(function(){
    var aTop = 0;
    var navblock= $('header'); 
    if($(this).scrollTop()>aTop){
      navblock.addClass('fixed'); 
    } else{
      navblock.removeClass('fixed');
    }
  });
  
  $('.js-menu-btn').on('click',function(){	
    var $this = $(this);
    var navBlock = $('.menu-wrap');
    $this.toggleClass('burger_active');
    if ($this.hasClass('burger_active')) {
      navBlock.animate({"right":"2%"});	
    } else {
      navBlock.animate({"right":"-96%"});	
    } 
  });




  $('.product-slider').each(function() {
    const $slider = $(this);    
    new Swiper($slider.find('.swiper-container')[0], {
      slidesPerView: 4,
      spaceBetween: 15,
      loop: true,
      navigation: {
        prevEl: $slider.closest('.center-sect').find('.js-productslider-prev')[0],
        nextEl: $slider.closest('.center-sect').find('.js-productslider-next')[0],
      },
      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 20 },
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 4, spaceBetween: 30 },
      },
      speed: 500,
      grabCursor: true,
    });
  });





 $('.js-form').submit(function(e) {

    e.preventDefault();
    let thisForm = $(this);
    let formData = new FormData($(this)[0]);					    
               
    console.log(formData);
    $.ajax({
        url: '/wp-admin/admin-ajax.php',
        type: 'POST',
        processData: false,
        contentType: false,
        data: formData, 
        dataType: "json",
        success: function(data) {
            console.log(data);

            const $elem = $('.js-popup[data-block="formthank"]');
            
            $('.js-popup').removeClass('is-show');

            $elem.addClass('is-show');


            setTimeout(function(){


 
      
            },3000);

        }		
    });

  });


     // Аккордеон
    $('.accordion-item__header').on('click', function() {
        const $currentItem = $(this).closest('.accordion-item');
        $currentItem.toggleClass('active');        
    });


    
    $('.faq-item__header').on('click', function() {       
        $(this).closest('.faq-item').toggleClass('active');             
    });

 


    const mainSlider = new Swiper('.product-main-slider', {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        pagination: {
            el: '.js-product-pag',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });




  $(document).on("click",".js-add-to-card",async function(e) {

		      e.preventDefault(); 

          let $thisbutton = $(this);	
          let product_qty = $thisbutton.attr("data-quantity");
          let product_id = $thisbutton.attr("data-product_id");
          let variation_id = $thisbutton.attr("data-variation_id");
          let size  = $thisbutton.attr('data-size');

          let data = {
              action: 'addtocart',
              product_id: product_id,
              product_sku: '',
              quantity: product_qty,
              variation_id : variation_id,
              size: size
          };
          console.log(data);
          
          $.ajax({
              type: 'POST',
              url: '/wp-admin/admin-ajax.php',
              data: data,
              beforeSend: function (response) {
                $thisbutton.attr("disabled",true);                
              },
              complete: function (response) {

              }, 
              success: function (response) { 

                  console.log(response);
                  if(response.in_cart){
                    $thisbutton.addClass('added');
                    $thisbutton.find("span.product-btn__text").text("Удалить");
                  } else {
                    $thisbutton.removeClass('added'); 
                    $thisbutton.find("span.product-btn__text").text("В корзину");
                  }
                  
                 
                  if(response.cart_count==0) $('.js-cart-count').addClass("hidden"); else $('.js-cart-count').removeClass("hidden")
                  $('.js-cart-count').text(response.cart_count);

                  // $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);

              
                  // console.log(response.fragments.basket);

                  // $('.modal--added').addClass("showmodal");

                  // setTimeout(function(){
                  //   $('.modal--added').removeClass("showmodal");
                  // },5000);

                  $thisbutton.attr("disabled",false);  
                           
                  $('.js-cart-count').html(response.cart_count);

                  $('.js-cart-count').show();

                  // $thisbutton.html('Добавлено');
                 
              }, 
          }); 


 

   

  }); 





  $(document).on("click",".cart-item__count .sign-minus", function(e) {
    e.preventDefault();
    var input = $(this).closest('.cart-item__count').find('input[type="number"]');
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal) && currentVal > input.attr('min')) {
      currentVal--;
      input.val(currentVal ).change();
    }

    input.trigger("change"); 
            
      $("[name='update_cart']").removeAttr('disabled');
      $("[name='update_cart']" ).trigger( 'click' );
    if($('.woocommerce-cart-form').length) {
    //   $(this).attr("disabled",true);

    //   // setTimeout(function(){
    //   //   location.reload();
    //   // },1000);

    } else {
      $('.card-sect__btns .js-add-to-card').attr("data-quantity",currentVal);
    }


  });

  // Обработчик для кнопки плюс
  $(document).on("click",".cart-item__count .sign-plus", function(e) {
    e.preventDefault();
    var input = $(this).closest('.cart-item__count').find('input[type="number"]');
    var currentVal = parseInt(input.val());
    currentVal++;
    input.val(currentVal).change();    
    input.trigger("change");
    $("[name='update_cart']").removeAttr('disabled');
      $("[name='update_cart']" ).trigger( 'click' );
    if($('.woocommerce-cart-form').length) {
    //   $(this).attr("disabled",true);
    //   // setTimeout(function(){
    //   //   location.reload();
    //   // },1000);
        
      $("[name='update_cart']").removeAttr('disabled');
      $("[name='update_cart']" ).trigger( 'click' );
    } else {
      $('.card-sect__btns .js-add-to-card').attr("data-quantity",currentVal);
    }



  });


  $('.cart-order-form').on('submit', function(e) {
          e.preventDefault();

          // Находим кнопку отпра вки
          var $submitBtn = $(this).find('.btn');
          var originalBtnText = $submitBtn.text();
          
          // Блокируем кнопку
          $submitBtn.prop('disabled', true).text('Оформление...');

          // Показываем индикатор загрузки
          // $('#order-response')
          //     .removeClass('success error')
          //     .html('<div class="loading-message">Оформляем заказ...</div>')
          //     .show();

          // Получаем выбранный способ оплаты
          var selectedPayment = $('input[name="paytype"]:checked').val();
          
          // Собираем данные формы
          var formData = {
              action: 'create_order_from_cart',
              nonce: $('#order_nonce').val(),
              customer_name: $('input[name="customer_name"]').val(),
              customer_email: $('input[name="customer_email"]').val(),
              customer_phone: $('input[name="phone"]').val(),
              customer_date: $('input[name="date"]').val(),
              customer_address: $('input[name="address"]').val(), // Исправлено name
              customer_elevator: $('input[name="elevator"]').val(), // Исправлено name
              customer_floor: $('input[name="floor"]').val(), // Исправлено name
              customer_additional: $('input[name="added"]').val(),
              payment_method: selectedPayment,
              agree_terms: $('.js-agree').is(':checked') ? 'yes' : 'no'
          };
          console.log(formData); 

          // Отправляем AJAX запрос
          $.ajax({
              url: '/wp-admin/admin-ajax.php',
              type: 'POST',
              data: formData,
              dataType: 'json',
              success: function(response) {
                  if (response.success) {

                      $('js-order-num').text(response.data.order_number);
                      
                      const $elem = $('.js-popup[data-block="thank"]');
                      $('.js-popup').removeClass('is-show');
                      $elem.addClass('is-show');

                      
                      // Очищаем форму (опционально)
                      $('.cart-order-form')[0].reset();
                      

                      
                  } else {
                      showError(response.data);
                  }
                  
                  // Разблокируем кнопку
                  $submitBtn.prop('disabled', false).text(originalBtnText);
              },
              error: function(xhr, status, error) {
                  console.error('AJAX Error:', status, error);
                  showError('Произошла ошибка при отправке. Пожалуйста, попробуйте еще раз или свяжитесь с нами по телефону.');
                  $submitBtn.prop('disabled', false).text(originalBtnText);
              }
          });
          
          function showError(message) {
              $('#order-response')
                  .removeClass('loading-message') 
                  .addClass('error')
                  .html('<div class="error-message">' +
                      '<h4>❌ Ошибка</h4>' +
                      '<p>' + message + '</p>' +
                      '</div>');
          }
      });

      // Валидация телефона (пример)
      $('input[name="customer_phone"]').on('input', function() {
          this.value = this.value.replace(/[^0-9+]/g, '');
      });

      // Подсветка выбранного способа оплаты
      $('.paytype-item input[type="radio"]').on('change', function() {
          $('.paytype-item').removeClass('selected');
          $(this).closest('.paytype-item').addClass('selected');
      });

      // $('.categories-list__item').on('hover', function() {
      //     let index=$(this).data("index");
      //     $('.categories__img').removeClass("active");
      //     $('.categories__img-'+index).addClass("active");

      //     $('.categories__about').removeClass("active");
      //     $('.categories__about-'+index).addClass("active");

      // });
      
  const $items = $('.categories-list__item');
    const defaultIndex = 1;
    
    function activateItem(index) {
        $('.categories__img, .categories__about').removeClass('active')

          $(`.categories__img-${index}, .categories__about-${index}`)
                    .addClass('active');
    }
    
    $items.on('mouseenter', function() {
        activateItem($(this).data('index'));
    });
    
    // $items.on('mouseleave', function() {
    //     activateItem(defaultIndex);
    // });
    
    $items.on('click touchstart', function(e) {
        e.preventDefault();
        activateItem($(this).data('index'));
    });


    $('.js-select-label').on('change', function() {
    
    filter();
});

  function filter(){



    $('.js-load-more').hide();
    
    let product_cat=$('.filter-data').attr('data-cat');	  
  
    
    let direction=$('.js-select-label').find('option:selected').data('direction');
    let order_by=$('.js-select-label').find('option:selected').val();

     let data = {
       action: 'productfilter',   
       product_cat: product_cat,      
       direction: direction,
       order_by: order_by,
     } 	
   
 
  
 
   
     $.ajax({
       url: '/wp-admin/admin-ajax.php',
       data: data,
       type: 'POST',
       beforeSend: function(){				
       },  
       success: function(data){  
  
        // if($(window).width()<=768){
        //   $("html, body").animate({
        //     scrollTop: ($('.js-products-results').offset().top-100) + "px"
        //   });
        // }

        $('.js-products-results').html(data);	
        
        // $('.products-more').hide();
         
       }
     }); 
 
    
 
  }


});